import React, { useState, useContext } from "react";
import {
  manageMapperStore,
  MANAGE_MAPPER_POST_API_ERROR,
  setManageMapperToastInfo,
  setMapperPostResponse,
} from "../../../contexts";
import { useRouterParams } from "../../../abstracts";
import {
  getAdvancedPathWithParam,
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  ROUTES,
} from "../../../utils";
import {
  LoaderWrapper,
  ManageMapperLayout,
  ScrollTable,
} from "../../../components";
import { faCaretRight, faCaretLeft } from "@fortawesome/pro-solid-svg-icons";
import { faCloudDownload, faSearch } from "@fortawesome/pro-regular-svg-icons";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { get } from "lodash-es";
import VerifyMapFixedWidthContainer from "./VerifyMapFixedWidthContainer";
import VerifyMapExcelOutputContainer from "./VerifyMapExcelOutputContainer";

const VerifyMapOutputContainer = (props) => {
  const { history } = props;
  const { flow, profileId, mapType } = useRouterParams();
  const { state, dispatch } = useContext(manageMapperStore);
  const apiData = get(state, "api.data", {});
  const outputFileName = get(state, "api.data.fileName", "");
  const passthroughFileName = get(state, "api.data.targetFileName", "");
  const fileName = mapType == 3 ? passthroughFileName : outputFileName;
  const outputMappingObjectMaps = get(state, "api.data.mappingObjectMaps", []);
  const passthroughObjectMaps = get(state, "api.data.outputTemplateMaps", []);
  const mappingObjectMaps =
    mapType == 3 ? passthroughObjectMaps : outputMappingObjectMaps;
  const fixedWidthOutputSections = get(
    state,
    "api.data.fixedWidthOutputSections",
    []
  );
  const tableRef = useRef();
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: getPathWithParam({
        path: `${ROUTES.MAPPER_HOME}`,
      }),
    },

    {
      label: "Next",
      variant: "primary",
      type: "submit",
      link:
        mapType != 1
          ? getPathWithParam({
              path: `${MANAGE_MAPPER_ROUTES.OUTPUT_FILTER}`,
              pathParam: [flow, mapType, profileId],
            })
          : getPathWithParam({
              path: `${MANAGE_MAPPER_ROUTES.OVERVIEW}`,
              pathParam: [flow, mapType, profileId],
            }),
    },
  ];

  const arrayObject = [
    {
      header: "First Name",
      value: "James",
    },
    {
      header: "Last Name",
      value: "Bond",
    },
    {
      header: "Middle Name",
      value: "R",
    },
    {
      header: "SSN",
      value: "3456-80-9862",
    },
    {
      header: "Address1",
      value: "14 Manhattan Central Park",
    },
    {
      header: "Address2",
      value: "14 Manhattan Central Park",
    },
    {
      header: "City",
      value: "14 Manhattan Central Park ",
    },
    {
      header: "Gender",
      value: "M",
    },
    {
      header: "State",
      value: "New York",
    },
  ];

  const fixedWidthObj = [
    {
      sectionName: "section 1",
      data: [
        "James",
        "Bond",
        "R",
        "3456-80-9862",
        "14 Manhattan Central Park",
        "14 Manhattan Central Park",
        "14 Manhattan Central Park",
        "M",
        "New York",
      ],
    },
    {
      sectionName: " section2",
      data: [
        "James",
        "Bond",
        "R",
        "3456-80-9862",
        "14 Manhattan Central Park",
        "NYC",
        "NYC",
        "M",
        "New York",
      ],
    },
  ];

  return (
    <ManageMapperLayout buttons={buttons} layoutHeader="Verify Map">
      {get(apiData, "format") == 2 ? (
        <VerifyMapFixedWidthContainer
          fixedWidthObj={fixedWidthOutputSections}
          fileName={fileName}
          state={state}
        />
      ) : (
        <VerifyMapExcelOutputContainer
          arrayObject={mappingObjectMaps}
          fileName={fileName}
          mapType={mapType}
        />
      )}
    </ManageMapperLayout>
  );
};

export default VerifyMapOutputContainer;
